/**
 * Court-related strings.
 *
 * Help text (h_) is seeded from the court schema field comments
 * (server/src/schemas/court.ts) — verify against the implementation.
 */
export default {
    d_jurisdiction: 'Jurisdiction',
    h_jurisdiction: "The court's CourtListener jurisdiction classification — for example FD (Federal District), ST (State Trial), or SA (State Appellate). It categorizes the court so the right deadline rules can be applied.",

    d_courtCode: 'Court Code',
    h_courtCode: 'The short CourtListener identifier for this court (e.g. txsd for the U.S. District Court, Southern District of Texas). Used to match court data on import.',

    d_citationString: 'Citation',
    h_citationString: 'The Bluebook citation abbreviation for this court (e.g. S.D. Tex.), used when citing the court in documents.',

    d_district: 'District',
    h_district: 'For a federal district court, the district within the state (e.g. Southern, Northern).',

    d_circuit: 'Circuit',
    h_circuit: 'For a federal appellate court, the circuit (e.g. 5th, 9th).',
};
